import moment from 'moment';
export default {
  name: 'article-card',
  props: {
    articleList: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  filters: {
    dateFormatter(value) {
      const strLength = 10;
      if (value.toString().length <= strLength) {
        return moment.unix(value).format('YYYY.MM.DD') || '-';
      }
      return moment(value).format('YYYY.MM.DD') || '-';
    }
  }
};